// @flow
import React, { PureComponent } from "react";
import { withRouter } from "react-router";
import type { ContextRouter } from "react-router";
import glamorous from "glamorous";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import consts from "common/consts";
import t from "common/i18n";
import { asAbsolute } from "root/routes/utils";
import { shouldUseColors } from "utils/colorUtils";
import { selectPalette } from "../../selectors";

type Props = {|
	...ContextRouter,
	palette: Object,
	history: Object,
|};

export const LOGO_ON_LIGHT_BG_SRC = "https://res-s.cloudinary.com/cloudinary/image/upload/v1522227140/upload-widget-2-assets/powered-by-new.svg";
export const LOGO_ON_DARK_BG_SRC = "https://res-s.cloudinary.com/cloudinary/image/upload/v1522227140/upload-widget-2-assets/powered-by-on-dark.svg";

const Wrapper = glamorous.div("db pointer", {
	height: "100%",
	width: "50px",
});

export class PoweredBy extends PureComponent<Props> {
	onButtonClick = () => {
		this.props.history.push(asAbsolute(consts.ABOUT));
	};

	render() {
		const { palette } = this.props;
		const logoSrc = shouldUseColors(palette.window, "#000") ? LOGO_ON_LIGHT_BG_SRC : LOGO_ON_DARK_BG_SRC;

		return <Wrapper onClick={this.onButtonClick} title={t("about_uw")}>
			<img data-test="powered-by-image" src={logoSrc} className="w-100 h-100"/>
		</Wrapper>;
	}
}

export default connect<Props, *, _, _, _, _>(
	createStructuredSelector({
		palette: selectPalette,
	}),
)(withRouter<Props>(PoweredBy));
